// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-summary-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  container-type: inline-size;
  width: 100%;
  height: 100%;
  min-width: 328px;
  background-color: var(--surface-primary);
}

.fund-summary-content {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
  padding: 0 16px;
}

/* Two-column row: chart (left) + details (right).
   Mobile-first: stacked by default, side-by-side from 768px up. */
.fund-summary-row {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;
  width: 100%;
}

.fund-summary-row__col {
  display: flex;
  width: 100%;
  flex: 1;
  flex-basis: auto;
  min-width: 0;
  flex-direction: column;
  gap: 16px;
}

.fund-summary-row__spacer {
  flex: 0 0 1px;
  align-self: stretch;
  background-color: var(--border-tertiary);
}

@container (min-width: 768px) {
  .fund-summary-content,
  .fund-summary-state {
    padding: 0 32px;
  }
  .fund-summary-row {
    flex-direction: row;
  }

  .fund-summary-row__col {
    flex-basis: 0;
    min-width: 0;
  }
}

.fund-summary-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 120px;
  padding: 0 32px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/FundSummaryWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;kEACkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".fund-summary-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  container-type: inline-size;\n  width: 100%;\n  height: 100%;\n  min-width: 328px;\n  background-color: var(--surface-primary);\n}\n\n.fund-summary-content {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  gap: 24px;\n  align-items: flex-start;\n  width: 100%;\n  padding: 0 16px;\n}\n\n/* Two-column row: chart (left) + details (right).\n   Mobile-first: stacked by default, side-by-side from 768px up. */\n.fund-summary-row {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n}\n\n.fund-summary-row__col {\n  display: flex;\n  width: 100%;\n  flex: 1;\n  flex-basis: auto;\n  min-width: 0;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.fund-summary-row__spacer {\n  flex: 0 0 1px;\n  align-self: stretch;\n  background-color: var(--border-tertiary);\n}\n\n@container (min-width: 768px) {\n  .fund-summary-content,\n  .fund-summary-state {\n    padding: 0 32px;\n  }\n  .fund-summary-row {\n    flex-direction: row;\n  }\n\n  .fund-summary-row__col {\n    flex-basis: 0;\n    min-width: 0;\n  }\n}\n\n.fund-summary-state {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 120px;\n  padding: 0 32px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
